export default __webpack_public_path__ + "static/media/arrow-down.e88fd881.svg";